"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSaveAllGuidelinesPanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _toast = require("../../utils/toast");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _useDioptraFetch2 = require("../../hooks/use-dioptra-fetch");
var _useLocalCopySyncedByContent = require("../../hooks/use-local-copy-synced-by-content");
var _envManager = require("../../utils/envManager");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useSaveAllGuidelinesPanel = exports.useSaveAllGuidelinesPanel = function useSaveAllGuidelinesPanel(_ref) {
  var guidelines = _ref.guidelines,
    conversationId = _ref.conversationId,
    onGuidelineSaved = _ref.onGuidelineSaved,
    onGuidelineDismissed = _ref.onGuidelineDismissed,
    onGuidelineClick = _ref.onGuidelineClick,
    onToggleSelection = _ref.onToggleSelection,
    onToggleSelectAll = _ref.onToggleSelectAll;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDismissing = _useState4[0],
    setIsDismissing = _useState4[1];
  var _useLocalCopySyncedBy = (0, _useLocalCopySyncedByContent.useLocalCopySyncedByContent)(guidelines),
    _useLocalCopySyncedBy2 = _slicedToArray(_useLocalCopySyncedBy, 2),
    localGuidelines = _useLocalCopySyncedBy2[0],
    setLocalGuidelines = _useLocalCopySyncedBy2[1];
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var unsavedUndismissedGuidelines = localGuidelines.filter(function (g) {
    return !g.isSaved && !g.isDismissed;
  });
  var allUnsavedSelected = unsavedUndismissedGuidelines.length > 0 && unsavedUndismissedGuidelines.every(function (g) {
    return g.isSelected;
  });
  var someUnsavedSelected = unsavedUndismissedGuidelines.some(function (g) {
    return g.isSelected;
  });
  var allSavedOrDismissed = localGuidelines.every(function (g) {
    return g.isSaved || g.isDismissed;
  });
  var handleSaveAll = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _iterator, _step, _loop, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          setIsSaving(true);
          _context2.p = 1;
          _iterator = _createForOfIteratorHelper(localGuidelines);
          _context2.p = 2;
          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
            var guideline, newRule, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  guideline = _step.value;
                  if (!(!guideline.isSaved && !guideline.isDismissed && guideline.isSelected)) {
                    _context.n = 5;
                    break;
                  }
                  _context.p = 1;
                  _context.n = 2;
                  return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/user-rules"), {
                    method: "POST",
                    body: JSON.stringify({
                      name: guideline.name,
                      description: guideline.description || "",
                      category: guideline.category,
                      rule: guideline.rule,
                      type: "guideline",
                      importance: guideline.importance,
                      remedy: "- comment_once ".concat(guideline.comment || "")
                    })
                  });
                case 2:
                  newRule = _context.v;
                  _context.n = 3;
                  return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/playbook-rules"), {
                    method: "POST",
                    body: JSON.stringify({
                      userPlaybookId: guideline.playbookId,
                      userRuleId: newRule.id
                    })
                  });
                case 3:
                  onGuidelineSaved(guideline.id);

                  // Optimistically show the check mark before the next await
                  setLocalGuidelines(function (prev) {
                    return prev.map(function (g) {
                      return g.id === guideline.id ? _objectSpread(_objectSpread({}, g), {}, {
                        isSaved: true
                      }) : g;
                    });
                  });
                  _context.n = 5;
                  break;
                case 4:
                  _context.p = 4;
                  _t = _context.v;
                  (0, _toast.toastError)(_t);
                  sendError(_t instanceof Error ? _t : new Error(String(_t)), {
                    component: 'SaveAllGuidelinesPanel',
                    action: 'save_single_guideline',
                    guidelineId: guideline.id
                  });
                  // Continue with next guideline even if this one fails
                case 5:
                  return _context.a(2);
              }
            }, _loop, null, [[1, 4]]);
          });
          _iterator.s();
        case 3:
          if ((_step = _iterator.n()).done) {
            _context2.n = 5;
            break;
          }
          return _context2.d(_regeneratorValues(_loop()), 4);
        case 4:
          _context2.n = 3;
          break;
        case 5:
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t2 = _context2.v;
          _iterator.e(_t2);
        case 7:
          _context2.p = 7;
          _iterator.f();
          return _context2.f(7);
        case 8:
          _context2.n = 10;
          break;
        case 9:
          _context2.p = 9;
          _t3 = _context2.v;
          (0, _toast.toastError)(_t3);
          sendError(_t3 instanceof Error ? _t3 : new Error(String(_t3)), {
            component: 'SaveAllGuidelinesPanel',
            action: 'save_all_guidelines',
            conversationId: conversationId
          });
        case 10:
          _context2.p = 10;
          setIsSaving(false);
          return _context2.f(10);
        case 11:
          return _context2.a(2);
      }
    }, _callee, null, [[2, 6, 7, 8], [1, 9, 10, 11]]);
  })), [localGuidelines, setLocalGuidelines, conversationId, onGuidelineSaved, sendError, dioptraFetch]);
  var handleDismissAll = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var selectedOpenGuidelines;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          setIsDismissing(true);
          selectedOpenGuidelines = localGuidelines.filter(function (guideline) {
            return !guideline.isSaved && !guideline.isDismissed && guideline.isSelected;
          });
          _context3.n = 1;
          return Promise.allSettled(selectedOpenGuidelines.map(function (guideline) {
            return onGuidelineDismissed(guideline.id);
          }));
        case 1:
          setIsDismissing(false);
        case 2:
          return _context3.a(2);
      }
    }, _callee2);
  })), [localGuidelines, setLocalGuidelines, onGuidelineDismissed]);
  var titleContent = isSaving ? 'Saving...' : allSavedOrDismissed ? 'All Saved/Dismissed' : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: ["Save ", unsavedUndismissedGuidelines.filter(function (g) {
      return g.isSelected;
    }).length, " Guidelines"]
  });
  var buttonText = isSaving ? 'Saving...' : allSavedOrDismissed ? 'All Saved' : "Save ".concat(unsavedUndismissedGuidelines.filter(function (g) {
    return g.isSelected;
  }).length);
  var isSaveAllBlocked = isSaving || isDismissing || allSavedOrDismissed || !someUnsavedSelected;
  return {
    button: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: 'flex',
        gap: '6px'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleSaveAll,
        disabled: isSaveAllBlocked,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          padding: '3px 12px',
          backgroundColor: isSaveAllBlocked ? '#B0B0B0' : 'var(--primary)',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: isSaveAllBlocked ? 'not-allowed' : 'pointer',
          fontSize: '11px',
          transition: 'all 0.2s',
          height: '22px',
          minWidth: '80px',
          fontFamily: 'inherit'
        },
        children: buttonText
      }), !allSavedOrDismissed && someUnsavedSelected && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: handleDismissAll,
        disabled: isDismissing || isSaving,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          padding: '3px 12px',
          backgroundColor: 'white',
          color: isDismissing || isSaving ? '#B0B0B0' : 'var(--primary)',
          border: "1px solid ".concat(isDismissing || isSaving ? '#B0B0B0' : 'var(--primary)'),
          borderRadius: '3px',
          cursor: isDismissing || isSaving ? 'not-allowed' : 'pointer',
          fontSize: '11px',
          transition: 'all 0.2s',
          height: '22px',
          minWidth: '80px',
          fontFamily: 'inherit'
        },
        children: [isDismissing ? 'Dismissing...' : "Dismiss ".concat(unsavedUndismissedGuidelines.filter(function (g) {
          return g.isSelected;
        }).length), !isDismissing && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
          width: 14,
          height: 14
        })]
      })]
    }),
    title: titleContent,
    expandedContent: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-1.5",
      children: [unsavedUndismissedGuidelines.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 px-2 py-1.5 border-b border-[#E5E2DD]",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "checkbox",
          checked: allUnsavedSelected,
          onChange: onToggleSelectAll,
          className: "w-4 h-4 cursor-pointer accent-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "text-xs font-medium text-[#4a5568]",
          children: ["Select All (", unsavedUndismissedGuidelines.length, ")"]
        })]
      }), localGuidelines.map(function (guideline) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center gap-2 px-2 py-1.5 rounded text-xs transition-all ".concat(guideline.isSaved ? 'bg-white border border-[#E5E2DD]' : guideline.isDismissed ? 'bg-white border border-[#E5E2DD]' : 'bg-white border border-[#E5E2DD]'),
          children: [!guideline.isSaved && !guideline.isDismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "checkbox",
            checked: guideline.isSelected,
            onChange: function onChange(e) {
              e.stopPropagation();
              onToggleSelection(guideline.id);
            },
            className: "w-4 h-4 cursor-pointer accent-primary flex-shrink-0"
          }), guideline.isSaved && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
            width: 16,
            height: 16,
            className: "text-[#10B981] flex-shrink-0"
          }), guideline.isDismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
            width: 16,
            height: 16,
            className: "text-[#EF4444] flex-shrink-0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            onClick: function onClick() {
              return onGuidelineClick === null || onGuidelineClick === void 0 ? void 0 : onGuidelineClick(guideline.id);
            },
            className: "flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[#686766] cursor-pointer hover:text-[#4a5568] font-medium",
            title: guideline.name,
            children: guideline.name
          }), guideline.isSaved && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-[10px] text-[#10B981] font-medium",
            children: "Saved"
          }), guideline.isDismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-[10px] text-[#EF4444] font-medium",
            children: "Dismissed"
          })]
        }, guideline.id);
      })]
    })
  };
};